import { createSlice } from "@reduxjs/toolkit";
import {
  cacheUser,
  clearCachedUser,
  readCachedUser,
} from "../utils/userCache";
import { getImpersonation, stopImpersonation } from "../utils/impersonation";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    // Hydrate from the session cache so a hard refresh doesn't bounce
    // through the full /inituser flow again. Returns null when the cache is
    // missing or older than its TTL, which falls back to the normal init.
    user: readCachedUser(),
  },
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      cacheUser(action.payload);
    },
    logout: (state) => {
      state.user = null;
      clearCachedUser();
      // Signing out must never leave an admin preview behind.
      stopImpersonation();
    },
  },
});

export const { login, logout } = userSlice.actions;

// While an admin preview is active, every consumer of selectUser sees the
// previewed user; the signed-in admin stays untouched underneath and is
// available via selectRealUser for the few places that must not be fooled
// (session init, starting/ending previews).
export const selectUser = (state) =>
  getImpersonation()?.user || state.user.user;

export const selectRealUser = (state) => state.user.user;

export default userSlice.reducer;
